<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div>
            <DataTable :tableData="tableData" @view="view" 
            @history="showHistory" @edit="edit" @update="update"/>
        </div>
    </div>


    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="2"
            :fields="newFields" @submit="addComplaint"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView> 
    
    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        
        <div v-if="!state.modalLoading">
            <DynamicForm :columns="2"
                :fields="editFields" @submit="addComplaint"
                :submitting="state.submitting" :errors="state.errors"
                :success="state.success" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView>

    <ModalView
        :isVisible="state.viewModal"
        :fixclose="true"
        @close="state.viewModal = false">
            <div v-if="!state.modalLoading">
                <FormView :columns="2"
                    :fields="viewFields" @submit="sendNote"
                    :submitting="state.submitting" :errors="state.errors"
                    :success="state.success" />
            </div>
            <div v-else style="text-align: center;">
                <img src="@/assets/img/ajldr.gif" style="width:100px"/>
            </div>
        
    </ModalView>

    <ModalView
        :isVisible="state.historyModal"
        :fixclose="true"
        @close="state.historyModal = false">
        <div v-if="!state.historyLoading">
          <HistoryItem v-for="(item, i) in history" :key="i" :hitem="item"/>
        </div>
        <div v-else style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
        
    </ModalView>

    <ModalView
        :isVisible="state.updateModal"
        :fixclose="true"
        @close="state.updateModal = false">
            <div v-if="!state.modalLoading">
                <DynamicForm :columns="1"
                    :fields="updateFields" @submit="updateComplaint"
                    :submitting="state.submitting" :errors="state.errors"
                    :success="state.success" :listeners="state.updateListener" />
                <div class="statinfo" v-if="state.status =='S1'">
                    <h2>Status Guidelines</h2>
                    <div class="sinfo" v-for="(info,i) in statInfo" :key="i">
                        <h3> {{ info.stat }} </h3>
                        <p> {{ info.info }} </p>
                    </div>
                </div>
            </div>
            <div v-else style="text-align: center;">
                <img src="@/assets/img/ajldr.gif" style="width:100px"/>
            </div>
        
    </ModalView>
</template>
<script>
import icons from '@/assets/js/icons.js';
import { useRoute } from 'vue-router';
import { computed, defineComponent, ref, reactive, onMounted} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { usePermissions } from '@/composables/usePermissions';
import DynamicForm from '@/components/DynamicForm.vue';
import FormView from '@/components/FormView.vue';
import ModalView from '@/components/ModalView.vue';
import HistoryItem from '@/components/HistoryItem.vue';

export default defineComponent({
    name: 'ProfileView',
    components:{PageHeader, DataTable, DynamicForm, ModalView, FormView,
        HistoryItem
    },
    setup(){
        const { hasPermission } = usePermissions();
        const route = useRoute();
        const cus_id = computed(() => route.params.customerId)
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,loading:true,
            modalLoading:false, editModal:false,viewModal:false,historyModal:false,historyLoading:false,
            updateModal:false,updateListener:{}
        })
        const staff=ref([])
        const statInfo=ref([])
        const history=ref([])
        const status=ref([])
        const page=ref({title:"Customers Complaints", btn:"Add new",
            desc:"This page helps you log, track, and resolve customer issues efficiently. Assign complaints to the right team and monitor progress for timely resolutions"})
        var action_label=[icons.view],
        action=["view"]
        if(!hasPermission('CRM', 'create')){
            page.value.btn="";
        }
        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Complaint" },
                { label: "Date" },
                { label: "Priority" },
                { label: "Status" }
            ],
            options:{
                label:"Action",
                action_label:action_label,
                action:action
            },
            total:0
        });

        if(hasPermission('CRM', 'edit')){
            action.push("edit");
            action_label.push(icons.edit)
        }

        if(hasPermission('CRM', 'edit')){
            action.push("update");
            action_label.push(icons.update)
        }

        action_label.push(icons.row_info);
        action.push("history")

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        const priority=ref([]);
        const editFields=ref([]);
        const updateFields=ref([]);

        onMounted(() => {
            call({
                url:urls.customer,
                data:{startComplaints:cus_id.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        setTable(d.complaints);
                        priority.value=[];
                        Object.keys(d.priority).forEach(k => {
                            priority.value.push(d.priority[k])
                        })
                        statInfo.value=[];
                        Object.keys(d.statInfo).forEach(k => {
                            statInfo.value.push(d.statInfo[k])
                        })
                        page.value.title=d.name;
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        //cid	complaint	cdate	priority	
        const newFields=ref([
            { name: "Add Complaint", number: "1",data: 
                [   { type: 'date', name: 'cdate', label: 'Complaint Date',
                    value: ""  },
                    { type: 'select', name: 'priority', label: 'Complaint Priority',
                    value: "",options:priority  },
                    { type: 'wysiwyg', name: 'complaint', label: 'Complaint',
                    value: ""  },
                    { type: 'hidden', name: 'cid', value: cus_id.value }
                ]
            }
        ])

        const viewFields=ref([])

        function createNew(){
            state.CreateModal=true;
            state.submitting=false;
            state.error=[];
            state.success=false
        }
        
        function addComplaint(data){
            state.submitting=true;
            state.errors=[];
            data.addComplaint="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg);
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function view(i){
            state.modalLoading=true
            state.viewModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{getComplaint:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        viewFields.value.length=0;
                        var c=res.msg,
                        a={};
                        if(c.assignedto !=""){
                            a={type:"",name:"to",label:"Assigned To",value:c.assignedto};
                        }
                        viewFields.value.push(
                        { name: "View Complaint", number: "1",data: 
                            [
                                { type: 'date', name: 'cdate', label: 'Complaint Date',
                                value: c.cdate  },
                                { type: 'select', name: 'priority', label: 'Complaint Priority',
                                value: c.priority,options:priority  },
                                { type: 'textarea', name: 'complaint', label: 'Complaint',
                                value: c.complaint  },
                                { type: 'textarea', name: 'status', label: 'Status',
                                value: c.status  },
                                { type: 'textarea', name: 'date', label: 'Date Added',
                                value: c.date  },
                                { type: 'textarea', name: 'by', label: 'Added By',
                                value: c.by  },
                                a
                            ]
                        })
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function edit(i){
            state.modalLoading=true
            state.editModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{editComplaint:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        editFields.value.length=0;
                        var c=res.msg;
                        editFields.value.push(
                        { name: "Edit Complaint", number: "1",data: 
                            [
                                { type: 'date', name: 'cdate', label: 'Complaint Date',
                                value: c.cdate  },
                                { type: 'select', name: 'priority', label: 'Complaint Priority',
                                value: c.priority,options:priority  },
                                { type: 'wysiwyg', name: 'complaint', label: 'Complaint',
                                value: c.complaint  },
                                {type:"hidden", name:"cid", value:cus_id.value},
                                {type:"hidden", name:"id", value:id}
                            ]
                        })
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function showHistory(i){
            state.historyModal=true;
            state.historyLoading=true;
            var data={getComplaintHistory: tableData.value.rows[i].id};
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                state.historyLoading=false;
                if(res.status){
                    history.value=res.msg;
                }else{
                    alert(res)
                }
                }
            });
        }

        function update(i){
            state.modalLoading=true
            state.updateModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{getUpdateComplaint:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        updateFields.value.length=0;
                        var msg=res.msg;
                        state.status=msg.status;
                        
                        staff.value=[];
                        Object.keys(msg.staff).forEach(k => {
                            staff.value.push(msg.staff[k])
                        })
                        
                        status.value=[];
                        Object.keys(msg.status).forEach(k => {
                            status.value.push(msg.status[k])
                        })

                        state.updateListener={
                            status: {
                                change: (e) => updateUpdateForm(e.target.value,id,msg.assigned)
                            },
                        }
                        updateFields.value.push(
                            { name: "Update Status", number: "1",data: 
                                [
                                    { type: 'select', name: 'status', label: 'Complaint Status',
                                    value: "", options:status  },
                                    {type:"hidden", name:"updateComplaint", value:id}
                                ]
                            }
                        )
                        
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function updateComplaint(data){
            state.submitting=true;
            state.errors=[];
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        setTable(res.msg.c);
                        if(res.msg.info !=""){
                            alert(res.msg.info)
                        }
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function updateUpdateForm(stat,id,ass){
            updateFields.value.length=0;
            if(stat=="S2"){
                updateFields.value.push(
                    { name: "Update Status", number: "1",data: 
                        [
                            { type: 'select', name: 'status', label: 'Complaint Status',
                            value: stat, options:status  },
                            { type: 'select', name: 'staff', label: 'Assign To',
                            value:ass,options:staff},
                            {type:"hidden", name:"assigncomplaint", value:id}
                        ]
                    }
                )
            }else{
                updateFields.value.push(
                    { name: "Update Status", number: "1",data: 
                        [
                            { type: 'select', name: 'status', label: 'Complaint Status',
                            value: stat, options:status  },
                            {type:"hidden", name:"updateComplaint", value:id}
                        ]
                    }
                )
            }
        }


        return{cus_id,tableData, state,page,newFields, createNew,addComplaint,view,
            viewFields,showHistory,history, edit,editFields,update,updateFields,statInfo,
            updateComplaint,status
        }
    }
})
</script>
<style scoped>
.statinfo{border-top: 1px solid var(--data-table-border);padding: 20px 10px;}
.statinfo h2{color:var(--black); font-size: 20px; margin: 0; margin-bottom: 10px;}
.sinfo h3{color: var(--black);margin: 0; font-size: 15px;}
.sinfo p{color: var(--light-text-color);font-size: 13px;}
</style>